module.exports = __webpack_public_path__ + "media/src/assets/images/img-travel-5-a5775eae93dc5d4f3e15bda14c4859d5.png";